import { render, staticRenderFns } from "./index.vue?vue&type=template&id=281490da&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281490da')) {
      api.createRecord('281490da', component.options)
    } else {
      api.reload('281490da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=281490da&", function () {
      api.rerender('281490da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/app/index.vue"
export default component.exports